<template>
  <v-dialog v-model="showDialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <slot v-bind="{ on }"></slot>
    </template>
    <v-card>
      <v-card-title class="headline">
        {{ $t('Preview audio') }}
      </v-card-title>
      <v-card-text>
        <div class="text-xs-center">
          <audio :src="audioUrl" controls></audio>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="showDialog = false">
          {{ $t('Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['audioUrl'],
  data: function() {
    return {
      showDialog: false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/DialogPreviewAudio.vue